import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NotifierWrapService } from '../../../services/notifier-wrap.service';
import { IMessengerConnector } from '../../../types/all.type';
import {NgxModalDraggableDirective} from '../../../directives/draggable.directive';
import {InterfaceService} from '../../../services/interface.service';

@Component({
  selector: 'app-modal-add-chat-member',
  templateUrl: './modal-add-chat-member.component.html',
  styleUrls: ['./modal-add-chat-member.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalAddChatMemberComponent implements OnInit {
  @Input() Service: IMessengerConnector;
  @Input() chatId: any;
  public modalDirective: NgxModalDraggableDirective;
  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }
  constructor(
    public interfaceService: InterfaceService,
    public bsModalRef: BsModalRef,
    private cd: ChangeDetectorRef,
    public notifierWrapService: NotifierWrapService
  ) {}

  ngOnInit(): void {
    this.cd.detectChanges();
  }
  toggleUser(user) {
    let chatId = this.chatId;
    if (this.Service.type === 'vk' && this.chatId > 2000000000) {
      chatId -= 2000000000;
    }
    this.Service.addChatUser(chatId, user.id).subscribe(
      (result: any) => {
        this.notifierWrapService.notify('success', 'Собеседник добавлен');
        this.bsModalRef.hide();
      },
      (error) => {
        this.interfaceService.errorHandling(error);
      }
    );
  }
}
